import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScreenShareinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		clipPath: "url(#a)",
		children: [/* @__PURE__ */ _jsx("path", { d: "M5 17h-.5A2.5 2.5 0 0 1 2 14.5v-9A2.5 2.5 0 0 1 4.5 3h15A2.5 2.5 0 0 1 22 5.5v9a2.5 2.5 0 0 1-2.5 2.5H19" }), /* @__PURE__ */ _jsx("path", {
			d: "m11.184 13.422-4.248 6A1 1 0 0 0 7.752 21h8.496a1 1 0 0 0 .816-1.578l-4.248-6a1 1 0 0 0-1.632 0",
			clipRule: "evenodd"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h24v24H0z"
		})
	}) })]
});
export default SvgScreenShareinline;
